import { HiresQuery } from "../../gql/graphql"

export interface CompanyHiresEngagement {
  name?: string | null
  employmentId: string
}

export enum CompanyHiresModalTypes {
  Delete = "delete",
  Cancel = "cancel",
}

export type HiresEngagement = HiresQuery["hires"]["collection"][number]
